export default "__VITE_ASSET__CN7wl7E4__"